import { render, staticRenderFns } from "./proveniente.vue?vue&type=template&id=e610910c"
import script from "./proveniente.vue?vue&type=script&lang=js"
export * from "./proveniente.vue?vue&type=script&lang=js"
import style0 from "./proveniente.vue?vue&type=style&index=0&id=e610910c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports